import { Component, OnDestroy, OnInit } from '@angular/core';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { ProjectDataService } from '../shared/services/project-data.service';
import { Subscription } from 'rxjs';
import { ProjectGroup } from '../shared/interfaces/project-group.interface';
import { ProjectRouteStation } from '../shared/interfaces/project-route-station.interface';
import { Project } from '../shared/interfaces/project.interface';
import { SchemaRouteStationModalComponent } from '../project-schema/schema-route-station-modal/schema-route-station-modal.component';
import { MatDialog } from "@angular/material/dialog";
import { ProjectRouteStationWithParam } from '../shared/interfaces/project-route-station.class';
import { environment } from 'src/environments/environment';
import { ImageDataService } from '../shared/services/image-data.service';
import { ProjectImageData } from '../shared/interfaces/project-image-data.interface';
import { ProjectMarkerObject } from './shared/interfaces/project-marker-object';
import { GroupMarkerObject } from './shared/interfaces/group-marker-object';
import { RouteStationMarkerObject } from './shared/interfaces/route-station-marker-object';
import { Location } from '@angular/common';
import { cloneDeep, set } from 'lodash';
import { GroupService } from '../shared/services/group.service';
import { DeviceTypeEnum } from 'src/app/device/shared/enums/device-type.enum';
import { CameraViewModalComponent } from '../project-schema/shared/components/camera-view-modal/camera-view-modal.component';
import { UserDataService } from 'src/app/user/shared/services/user-data.service';
import { CameraTypeEnum, getCameraType } from '../shared/enums/camera-type.enum';
import { SchemaIndicatorEnum } from '../project-schema/shared/enums/schema-indicator.enum';
import { MapConsentService } from 'src/app/shared/map-consent/shared/map-consent.service'

@Component({
  selector: 'avs-project-googlemaps',
  templateUrl: './project-googlemaps.component.html',
  styleUrls: ['./project-googlemaps.component.css']
})
export class ProjectGooglemapsComponent implements OnInit, OnDestroy { /* ondelete fehlt noch, um subs zu dismissen */

  public map?: google.maps.Map;
  public isMapLoaded: boolean = false;
  public isMapConsentGiven: boolean = false;
  public isMapInitStarted: boolean = false;
  public mapConsentSubscription?: Subscription;
  public center: google.maps.LatLngLiteral = { lat: 51.095123, lng: 10.241483 };
  public activeProject: Project | undefined;
  public projects: Project[] = [];
  public projectGroups: ProjectGroup[] = [];
  public allGroups: ProjectGroup[] = [];
  public groupsRouteStationsWithParams: ProjectRouteStationWithParam[] | undefined;
  public activeGroup: ProjectGroup | undefined;
  public projectPins?: ProjectMarkerObject[] = [];
  public projectMarkers: google.maps.marker.AdvancedMarkerElement[] = [];
  public groupPins?: GroupMarkerObject[];
  public groupMarkers: google.maps.marker.AdvancedMarkerElement[] = [];
  public routeStationPins?: RouteStationMarkerObject[];
  public routeStationMarkers: google.maps.marker.AdvancedMarkerElement[] = [];
  public activeRouteStation: ProjectRouteStation | undefined;
  public projectImagesSubscription?: Subscription;
  public projectsSubscription?: Subscription;
  public groupsSubscription?: Subscription;
  public routeStationsSubscription?: Subscription;
  public routeStationsWithParamSubscription?: Subscription;
  public projectRouteStationsWithParamSubscription?: Subscription;
  public images: ProjectImageData[] = [];
  public allImages: ProjectImageData[] = [];
  public projectClusterer?: MarkerClusterer
  public apiAddress: string = environment.apiAddress;
  private transitLayer?: google.maps.TransitLayer;
  private trafficLayer?: google.maps.TrafficLayer;
  private spherical?: any;
  public isTransitLayerActive: boolean = false;
  public isTrafficLayerActive: boolean = false;

  public timer: any;
  public countdown: number = 30;
  public isTimerActive: boolean = false;
  public isMapDrawn: boolean = false;
  public isGroupBackButtonDrawn: boolean = false;
  public isRouteStationBackButtonDrawn: boolean = false;
  public clickCoordinates: google.maps.LatLngLiteral[] = [];

  markers: google.maps.marker.AdvancedMarkerElement[] = [];
  lines: google.maps.Polyline[] = [];
  totalDistance = 0;
  isMeasuring = false;

  constructor(private readonly projectDataService: ProjectDataService,
    private dialog: MatDialog, private imageDataService: ImageDataService,
    private location: Location,
    private groupService: GroupService,
    private userDataService: UserDataService,
    private mapConsentService:MapConsentService) {
    this.mapConsentSubscription = mapConsentService.isConsentGiven.subscribe(isConsentGiven => {
      this.isMapConsentGiven = isConsentGiven;
      if (!isConsentGiven) {
        this.destroyMap();
        return;
      }
      if (this.projects.length === 0) 
        return;
      setTimeout(() => this.initMap(), 50);
    });
    this.projectsSubscription = projectDataService.filteredProjects.subscribe(projects => {
      if (projects === undefined) { return }
      else {
        this.destroyGroupMarkers();
        this.destroyRouteStationMarkers();
        if (projects !== this.projects) {
          this.showProjectClusterer(false);
          this.createProjectPins(projects);
          this.projects = projects;
          if (this.isMapLoaded === false && this.projects.length > 0) {
            setTimeout(() => this.initMap(), 50);
          }
          this.setProjectMarkers();
        }
      }
    });
    this.groupsSubscription = projectDataService.projectGroups.subscribe(groups => {
      if (this.projectPins?.length !== this.projectMarkers.length) { this.setProjectMarkers(); }
      if (groups.length === 0 && this.projectPins!.length > 0) { this.showProjectClusterer(true); this.showGroupBackButton(false) }
      if (groups.length === 0 && this.projectPins?.length === 0) { this.createProjectPins(this.projects); this.showGroupBackButton(false) }
      this.projectGroups = groups;
      if (this.routeStationMarkers.length > 0) this.destroyRouteStationMarkers();
      if (groups.length === 0) {
        this.destroyGroupMarkers();
      }
      if (groups.length > 0) {
        this.generateGroupPins(groups);

        this.showGroupBackButton(true);
      }
    });
    this.projectRouteStationsWithParamSubscription = projectDataService.projectsRouteStationsWithParam.subscribe(routeStations => {
      this.destroyRouteStationMarkers();
      if (routeStations === undefined) { this.generateGroupPins(this.projectGroups); this.showRouteStationBackButton(false, true); this.stopTimer(); this.isTimerActive = false; return }
      this.groupsRouteStationsWithParams = routeStations;
      if (routeStations)
        if (routeStations.length > 0) {
          this.destroyGroupMarkers();
          this.showGroupBackButton(false);
          this.generateRouteStationPins(routeStations);
          this.showRouteStationBackButton(true);
          this.isTimerActive = true;
          this.countdown = 30;
          this.startTimer();

        }
    });
    this.projectImagesSubscription = imageDataService.projectImages.subscribe(images => {
      this.images = images;
      this.allImages = images;
      this.rotateImagesPaths(this.images);

    });
  }
  private allowedRoles = ['Admin', 'AdminReadOnly', 'User'];
  public userRole: string | undefined;
  public ngOnInit(): void {
    this.userRole = this.userDataService.returnRoleAsString();
  }

  public ngOnDestroy(): void {
    this.projectsSubscription?.unsubscribe();
    this.groupsSubscription?.unsubscribe();
    this.routeStationsSubscription?.unsubscribe();
    this.projectRouteStationsWithParamSubscription?.unsubscribe();
    this.projectImagesSubscription?.unsubscribe();
    this.mapConsentSubscription?.unsubscribe();
    this.stopTimer();
  }
  public rotateImagesPaths(images: ProjectImageData[]): void {
    if (images === null || images === undefined) return;
    images.forEach(image => {
      if (image.isAnimated && image.animatedImageIds!.length > 0) { /* für jedes Bild, das für die RouteStation gesetzt wird, wird nun separat geprüft ob ein animatedImageId vorhanden ist */
        this.rotatePathForId(image)
      }
    });
  }
  public rotatePathForId(image: ProjectImageData): void {
    const myValueList = image.animatedImageIds!;

    let i = 0;
    const id = setInterval(() => {
      image.path = this.getPathByImageId(myValueList[i++]); /* iteration durchs animatedimage array, und zieht sich dasnn über die id, den path */
      if (i === myValueList.length) {
        i = 0;
      }
    }, 1000);
  }
  public getPathByImageId(imageId: number) {

    if (this.allImages) {
      let imageObject = this.allImages.find((x) => x.imageId == imageId)
      return imageObject?.path as string
    }
    else return
  }

  private createProjectPins(projects: Project[]): void {
    this.projectPins = [];
    this.projects = projects
    this.allGroups = [];
    projects.forEach(project => {
      this.allGroups.push(...project.groups);
    }
    )
    projects.forEach(project => {
      this.projectPins!.push({
        lat: project.latitude,
        lng: project.longitude,
        title: project.name,
        content: 'content',
        active: project.isActive,
        id: project.id
      });
    })
  }

  public stopTimer() {
    if (this.timer)
      clearInterval(this.timer)
  }

  private startTimer() {
    if (this.isMeasuring) { return }
    this.stopTimer();
    this.timer = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        this.triggerReload();
      }
    }, 1000);
  }

  public triggerReload() {
    let groupId = this.groupsRouteStationsWithParams?.[0].routeStation.groupId;
    if (groupId !== undefined)
      this.groupService.getProjectRouteStations(groupId).subscribe(routeStations => {
        this.projectDataService.updateProjectRouteStations(routeStations);
      });
    this.countdown = 30;
  }

  public generateGroupPins(groups: ProjectGroup[]): void {
    this.destroyGroupMarkers();
    this.destroyProjectMarkers();

    this.groupPins = [];
    let itemsProcessed = 0;
    groups.forEach(group => {

      this.groupPins!.push({
        lat: group.latitude,
        lng: group.longitude,
        title: group.name,
        content: 'content',
        active: group.isActive,
        id: group.id,
        street: group.routeName
      })
      itemsProcessed++;
      if (itemsProcessed === groups.length) {
        this.setGroupMarker(this.groupPins!, 'group');
      }
    }
    )
    if (groups.length > 0) {
      let projectId = groups[0].projectId;
      let project = this.projects.find(p => p.id === projectId);
      if (this.map !== undefined) {
        let bounds = new google.maps.LatLngBounds();
        groups.forEach(g => { bounds.extend({ lat: g.latitude, lng: g.longitude }) });
        this.map?.fitBounds(bounds);
        this.showGroupBackButton(true)
      }
    }
    else {
      this.map?.setZoom(8);
      this.map?.setCenter(this.center);
    }
  }
  public generateRouteStationPins(routeStations: ProjectRouteStationWithParam[]): void {
    this.showGroupBackButton(false);
    this.routeStationPins = [];
    let itemsProcessed = 0;
    routeStations.forEach(routeStation => {
      let schemaInfo = routeStation.schemaInfo;
      let display = schemaInfo?.displays?.[0]?.data;
      this.routeStationPins!.push({
        lat: schemaInfo?.gps?.data?.latitude
          ?? routeStation.routeStation?.latitude
          ?? 1.00000,
        lng: schemaInfo?.gps?.data?.longitude
          ?? routeStation.routeStation?.longitude
          ?? 1.00000, title: routeStation.routeStation.name,

        /* jeweils erweitern, dürfen beide nicht 0 sein; rücksprache jürgen dataStream  */

        content: 'content',
        id: routeStation.routeStation.samId,
        stellcode: display?.display?.code,
        name: routeStation.routeStation.name,
        blinker: this.toIndicatorString(schemaInfo?.lamp?.data?.indicator),
        indicatorLed: this.toIndicatorString(display?.display?.indicator),
        isBrennstoffzelle: schemaInfo?.fuelcell?.data != null,
        patrone1: schemaInfo?.fuelcell?.data?.fuelLevel?.[0],
        patrone2: schemaInfo?.fuelcell?.data?.fuelLevel?.[1],
        online: schemaInfo?.online === true,
        isAnimated: display?.isAnimated === true,
        mq: (schemaInfo?.radars?.length ?? 0) > 0 ? true : false,
        LPCam: schemaInfo?.deviceType === DeviceTypeEnum.LPCam ? true : false,
        DomeCam: schemaInfo?.deviceType === DeviceTypeEnum.DomeCam ? true : false,
        Weather: schemaInfo?.deviceType === DeviceTypeEnum.Weather ? true : false
      })
      itemsProcessed++;
      if (itemsProcessed === routeStations.length) {
        this.setrouteStationMarkers(this.routeStationPins!, 'routeStation');
      }
    })
    let bounds = new google.maps.LatLngBounds();
    this.waitForMap().then(() => {
      routeStations.forEach(rs => {
        bounds.extend({
          lat: rs.schemaInfo?.gps?.data?.latitude
            ?? rs.routeStation?.latitude
            ?? 1.00000,
          lng: rs.schemaInfo?.gps?.data?.longitude
            ?? rs.routeStation?.longitude
            ?? 1.00000
        });
      }); this.map?.fitBounds(bounds);
    });
  }


  /** Übersetzt den Schema-Indicator in die Rohdaten-Strings der Marker-Logik. */
  private toIndicatorString(indicator?: SchemaIndicatorEnum | null): string | null {
    if (indicator === SchemaIndicatorEnum.On) { return 'einschalten'; }
    if (indicator === SchemaIndicatorEnum.Off) { return 'ausschalten'; }
    return null;
  }

  public destroyGroupMarkers(): void {
    this.groupMarkers.forEach(marker => {
      marker.map = null;
    })
  }

  public destroyProjectMarkers(): void {
    this.projectMarkers.forEach(marker => {
      marker.map = null;
    })
  }

  public destroyRouteStationMarkers(): void {
    this.routeStationMarkers.forEach(marker => {
      marker.map = null;
    })
  }

  public getAllGroups() {
    this.allGroups = [];
    this.projects.forEach(project => {
      this.allGroups.push(...project.groups);
    })
  }

  toggleMeasure() {
    /* reload stoppen? ansonsten wird ja die position auf der karte neu bestimmt */
    this.isMeasuring = !this.isMeasuring;
    this.resetMeasurement()
    if (!this.isMeasuring) {
      this.totalDistance = 0;
    }
  }

  public distanceInfoWindow?: google.maps.InfoWindow;

  private showDistanceAtLastMarker() {
    if (this.markers.length === 0) return;

    // Close previous InfoWindow if any
    if (this.distanceInfoWindow) {
      this.distanceInfoWindow.close();
    }

    const lastMarker = this.markers[this.markers.length - 1];
    const position = lastMarker.position;

    this.distanceInfoWindow = new google.maps.InfoWindow({
      content: `<div style="font-size:14px; margin-top: 10px"> Strecke: ${this.totalDistance.toFixed(2)} m</div>`
    });

    // Open the InfoWindow at the last marker
    this.distanceInfoWindow.open(this.map, lastMarker);
  }
  async initMap() {
      if (!this.isMapConsentGiven || this.map)
      return;
      this.isMapInitStarted = true;
      this.mapConsentService.loadGoogleMaps().then(async () => {
      const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
      const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
      const { spherical } = await google.maps.importLibrary("geometry") as google.maps.GeometryLibrary;
      this.transitLayer = new google.maps.TransitLayer();
      this.trafficLayer = new google.maps.TrafficLayer();

      this.spherical = spherical;

      this.map = new Map(document.getElementById("map") as HTMLElement, { /* TODO: beobachten; falls nochmal während reportings triggered */
        zoom: 6,
        center: this.center,
        mapId: "avs-map",
        mapTypeControl: true,
        scaleControl: true,
        maxZoom: 19,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          mapTypeIds: ["roadmap", "terrain", "satellite", "hybrid"],
        },

        gestureHandling: "greedy",

      });
      // Add click listener for measurement
      this.map.addListener("click", (event: google.maps.MapMouseEvent) => {
        this.addMarker(event);
      });

      if (this.projectPins!.length > 0) {
        this.setProjectMarkers();
      }
      this.addGroupBackButton();
      this.addRouteStationBackButton();

      this.onOffButtonTransitLayer();
      this.onOffButtonTrafficLayer();
      this.onOffButtonMeasure();
      this.isMapDrawn = true;
      this.isMapLoaded = true;
    })
  }

  private destroyMap(): void {
    this.destroyProjectMarkers();
    this.destroyGroupMarkers();
    this.destroyRouteStationMarkers();
    this.resetMeasurement();
    this.map = undefined;
    this.isMapDrawn = false;
    this.isMapInitStarted = false;
    this.isGroupBackButtonDrawn = false;
    this.isRouteStationBackButtonDrawn = false;
  }

  public onRevokeMapConsentClicked(): void {
    this.mapConsentService.revokeConsent();
  }
  addMarker(event: google.maps.MapMouseEvent) {
    if (!this.isMeasuring || !event.latLng) return;

    const marker = new google.maps.marker.AdvancedMarkerElement({
      position: event.latLng,
      map: this.map // <-- Wichtig: Map-Referenz zuweisen
    });

    this.markers.push(marker);

    if (this.markers.length > 1) {
      this.updateLines();
      this.calculateDistances();
    }
  }
  resetMeasurement() {
    this.markers.forEach(marker => marker.map = null);
    this.lines.forEach(line => line.setMap(null));
    this.markers = [];
    this.lines = [];
  }

  private updateLines() {
    // Alte Linien entfernen
    this.lines.forEach(line => line.setMap(null));
    this.lines = [];

    for (let i = 1; i < this.markers.length; i++) {
      const prevPos = this.markers[i - 1].position;
      const currPos = this.markers[i].position;
      if (!prevPos || !currPos) {
        continue;
      }
      const line = new google.maps.Polyline({
        path: [
          prevPos,
          currPos
        ],
        strokeColor: '#FF0000',
        strokeOpacity: 1.0,
        strokeWeight: 2,
        map: this.map // <-- Map-Referenz setzen
      });

      this.lines.push(line);
    }
  }
  private calculateDistances() {
    this.totalDistance = 0;

    for (let i = 1; i < this.markers.length; i++) {
      const prevMarker = this.markers[i - 1];
      const currMarker = this.markers[i];

      // Position aus AdvancedMarkerElement holen
      if (!prevMarker.position || !currMarker.position) {
        continue;
      }
      const prevPos = prevMarker.position instanceof google.maps.LatLng
        ? prevMarker.position
        : new google.maps.LatLng(prevMarker.position.lat, prevMarker.position.lng);

      const currPos = currMarker.position instanceof google.maps.LatLng
        ? currMarker.position
        : new google.maps.LatLng(currMarker.position.lat, currMarker.position.lng);

      const segmentDistance = google.maps.geometry.spherical.computeDistanceBetween(prevPos, currPos);
      this.totalDistance += segmentDistance;

    }
    this.showDistanceAtLastMarker();
/*     this.updateLastMarkerLabel();
 */  }
  private updateLastMarkerLabel() {
    if (this.markers.length === 0) return;

    const lastMarker = this.markers[this.markers.length - 1];

    // Create a custom label element
    const labelDiv = document.createElement('div');
    labelDiv.style.background = 'white';
    labelDiv.style.border = '1px solid #333';
    labelDiv.style.padding = '2px 6px';
    labelDiv.style.borderRadius = '4px';
    labelDiv.style.fontSize = '12px';
    labelDiv.style.boxShadow = '0 2px 6px rgba(0,0,0,0.2)';
    labelDiv.innerText = `Total: ${this.totalDistance.toFixed(2)} m`;

    // Update the marker's content
    lastMarker.content = labelDiv;
  }





  drawLine() {
    if (this.clickCoordinates.length === 2) {
      const [point1, point2] = this.clickCoordinates;
      const line = new google.maps.Polyline({
        path: [
          { lat: point1.lat, lng: point1.lng },
          { lat: point2.lat, lng: point2.lng }
        ],
        geodesic: true,
        strokeColor: '#FF0000',
        strokeOpacity: 1.0,
        strokeWeight: 2,
      });
      line.setMap(this.map!);
    }
  }
  calculateDistance() {

    if (this.clickCoordinates.length === 2) {
      const [point1, point2] = this.clickCoordinates;
      const distance = this.spherical.computeDistanceBetween(
        new google.maps.LatLng(point1.lat, point1.lng),
        new google.maps.LatLng(point2.lat, point2.lng)
      );
      alert(`Distance: ${distance} meters`);
    }
  }
  enterProject(markerView: any, property: any) {
    let project = this.projects.find(p => p.id === property.id);
    if (this.activeProject === project) {
      if (this.activeGroup !== undefined) { this.projectDataService.updateActiveGroup(undefined); return }
      this.projectDataService.updateActiveProject(undefined);
    } else {
      this.projectDataService.updateActiveProject(project);
      this.map?.setCenter({ lat: project!.latitude, lng: project!.longitude });
      this.map?.setZoom(13);
    }
  }

  enterGroup(markerView: any, property: any) {
    let group = this.projectGroups.find(g => g.id === property.id);
    if (this.activeGroup === group) {
      this.projectDataService.updateActiveGroup(undefined);
    } else {
      this.projectDataService.updateActiveGroup(group);
      this.map?.setCenter({ lat: group!.latitude, lng: group!.longitude });
      this.map?.setZoom(16);
    }
  }
  private isRouteStationDialogOpen = false;

  enterRouteStation(markerView: any, property: any) {
    let routeStation = this.groupsRouteStationsWithParams!.find(rs => rs.routeStation.samId === property.id);
    if (this.activeRouteStation === routeStation) {
      this.projectDataService.updateActiveRouteStation(undefined);
    } else {
      this.projectDataService.updateActiveRouteStation(routeStation?.routeStation);


      /* prüfen was es ist und entsprechenden Dialog öffnen, (cams; station siehe schema) */
      /*       this.dialog.open(SchemaRouteStationModalComponent, { data: routeStation }).afterClosed().subscribe(
              result => {
      
              });
          } */

      const cams = routeStation?.schemaInfo?.cameras;
      const isCamera = Array.isArray(cams) &&
        (cams[0]?.camType === 18 || cams[0]?.camType === 19);

      if (!isCamera) {
        // Nur ein SchemaRouteStationModalComponent gleichzeitig
        if (this.isRouteStationDialogOpen) {
          return;
        }
        this.isRouteStationDialogOpen = true;

        this.projectDataService.updateActiveRouteStation(routeStation?.routeStation);
        this.dialog.open(SchemaRouteStationModalComponent, {
          data: cloneDeep(routeStation),
          maxHeight: '98vh',
          hasBackdrop: false,
          panelClass: 'draggable-resizable-dialog'
        }).afterClosed().subscribe(result => {
          this.isRouteStationDialogOpen = false;
          this.countdown = 5;
      /*     this.projectDataService.updateActiveGroup(this.activeGroup); */
          /*           if (result?.toDelete) {
                      this.deleteStationFromSchema(result.data);
                    }
                    if (result?.navigate) {
                      this.navigateToRouteStation(station);
                    } */
        });

      } else {
        // Kamera-Dialogs beliebig oft
        this.dialog.open(CameraViewModalComponent, {
          data: {
            name: routeStation?.routeStation.name,
            rs: routeStation?.routeStation.id,
            type: (cams && cams.length > 0 && cams[0].camType != null) ? getCameraType(cams[0].camType) : undefined
          },
          hasBackdrop: false,
          panelClass: 'draggable-resizable-dialog'
        }).afterClosed().subscribe(result => {
          if (result) {
            // Handle camera result
          }
        });
      }

    }
  }

  toggleHighlight(markerView: any, property: any) {
    if (markerView.content.classList.contains("highlight")) {
      markerView.content.classList.remove("highlight");
      markerView.zIndex = null;
    } else {
      markerView.content.classList.add("highlight");
      markerView.zIndex = 1;
    }
  }

  showProjectClusterer(bool: boolean) {
    if (bool) {
      if (this.projectPins?.length === this.projectMarkers.length) {
        this.projectMarkers.forEach(marker => {
          marker.map = this.map
        })
        this.projectClusterer?.addMarkers(this.projectMarkers);
      }
      else { this.createProjectPins(this.projects); }
    }
    else {
      this.projectClusterer?.removeMarkers(this.projectMarkers);
      this.projectMarkers.forEach(marker => {
        marker.map = null
      })
    }
  }

  setProjectMarkers() {
    if (this.map === undefined) return;

    this.projectMarkers = this.projectPins!.map((pin, i) => {
      const AdvancedMarkerElement = new google.maps.marker.AdvancedMarkerElement({
        map: this.map,
        content: this.buildContent(pin),
        position: { lat: pin.lat, lng: pin.lng },
        title: pin.title,
      });
      AdvancedMarkerElement.addListener("click", () => {
        this.enterProject(AdvancedMarkerElement, pin);
      });

      return AdvancedMarkerElement;
    });
    this.projectClusterer = new MarkerClusterer({ markers: this.projectMarkers, map: this.map });
  }

  public addGroupBackButton() {
    const backButton = document.createElement("button");
    backButton.classList.add("group-button");
    backButton.innerHTML = "Zurück";
    backButton.addEventListener("click", () => {
      this.projectDataService.updateActiveGroup(undefined);
      this.destroyGroupMarkers();
      this.showProjectClusterer(true); this.showGroupBackButton(false);
      let bounds = new google.maps.LatLngBounds();
      this.projects.forEach(p => { bounds.extend({ lat: p.latitude, lng: p.longitude }) });
      this.map?.fitBounds(bounds);

    });
    this.map?.controls[google.maps.ControlPosition.TOP_LEFT].push(backButton);
    this.isGroupBackButtonDrawn = true;
  }

  public addRouteStationBackButton() {
    const backButton = document.createElement("button");
    backButton.classList.add("route-station-button");
    backButton.innerHTML = " Zurück";
    backButton.addEventListener("click", () => {
      this.destroyRouteStationMarkers();
      this.generateGroupPins(this.projectGroups);
      this.showRouteStationBackButton(false);
      this.showGroupBackButton(true);
      let bounds = new google.maps.LatLngBounds();
      this.projectGroups.forEach(g => { bounds.extend({ lat: g.latitude, lng: g.longitude }) });
      this.map?.fitBounds(bounds);
      this.projectDataService.updateActiveGroup(this.activeGroup);
    });
    this.map?.controls[google.maps.ControlPosition.TOP_LEFT].push(backButton);
    this.isRouteStationBackButtonDrawn = true;

  }

  public showGroupBackButton(bool: boolean) {
    if (bool) {
      let groupbutton = document.querySelector('.group-button') as HTMLElement;
      if (groupbutton === null) {
        setTimeout(() => {
          this.showGroupBackButton(bool);
        }, 500);
      }
      if (groupbutton !== null) groupbutton.style.display = 'flex'
    }
    else {
      let groupbutton = document.querySelector('.group-button') as HTMLElement;
      if (groupbutton)
        groupbutton.style.display = 'none'
    }
  }

  public showRouteStationBackButton(bool: boolean, groupBool?: boolean) {

    if (bool) { this.showProjectClusterer(false); }
    if (this.map === undefined) {
      setTimeout(() => {
        this.showRouteStationBackButton(bool, groupBool);
      }, 500);
      return;
    }
    if (bool) {
      let routeStationButton = document.querySelector('.route-station-button') as HTMLElement;
      if (routeStationButton) { routeStationButton.style.display = 'flex' }
      else setTimeout(() => {
        this.showRouteStationBackButton(bool, groupBool);
      }, 500);
    }
    else {
      let routeStationButton = document.querySelector('.route-station-button') as HTMLElement;
      if (routeStationButton) { routeStationButton.style.display = 'none' }
      if (groupBool && this.projectGroups.length > 0) {

        this.generateGroupPins(this.projectGroups);
        this.showGroupBackButton(true);
      }
    }
  }

  public onOffButtonTransitLayer() {
    const transitLayerButton = document.createElement("button");
    transitLayerButton.classList.add("transit-layer-button");
    transitLayerButton.innerHTML = "Transit (aus)";

    transitLayerButton.addEventListener("click", () => {
      if (this.isTransitLayerActive) {
        this.transitLayer?.setMap(null);
        this.isTransitLayerActive = false;
        transitLayerButton.innerHTML = "Transit (aus)";
      }
      else {
        if (this.map === undefined) return;
        this.transitLayer?.setMap(this.map);
        this.isTransitLayerActive = true;
        transitLayerButton.innerHTML = "Transit (an)";
      }
    });
    this.map?.controls[google.maps.ControlPosition.TOP_RIGHT].push(transitLayerButton);
  }

  public onOffButtonTrafficLayer() {
    const trafficLayerButton = document.createElement("button");
    trafficLayerButton.classList.add("traffic-layer-button");
    trafficLayerButton.innerHTML = "Traffic (aus)";

    trafficLayerButton.addEventListener("click", () => {
      if (this.isTrafficLayerActive) {
        this.trafficLayer?.setMap(null);
        this.isTrafficLayerActive = false;
        trafficLayerButton.innerHTML = "Traffic (aus)";
      }
      else {
        if (this.map === undefined) return;
        this.trafficLayer?.setMap(this.map);
        this.isTrafficLayerActive = true;
        trafficLayerButton.innerHTML = "Traffic (an)";
      }
    });
    this.map?.controls[google.maps.ControlPosition.TOP_RIGHT].push(trafficLayerButton);
  }

  public onOffButtonMeasure() {
    const measureButton = document.createElement("button");
    measureButton.classList.add("measure-button");
    measureButton.innerHTML = "Messen (aus)";

    measureButton.addEventListener("click", () => {
      this.onOffMeasure();
      if (this.isMeasuring) {
        measureButton.innerHTML = "Messen (an)";
      }
      else {
        measureButton.innerHTML = "Messen (aus)";
      }
    });
    this.map?.controls[google.maps.ControlPosition.TOP_RIGHT].push(measureButton);
  }

  public onOffMeasure() {
    this.isMeasuring = !this.isMeasuring;
    if (this.isMeasuring) {
      this.stopTimer();
      this.resetMeasurement();
      this.map?.setOptions({ draggableCursor: 'crosshair' });
    } else {
      this.map?.setOptions({ draggableCursor: 'default' });
      this.resetMeasurement();
      this.startTimer();
    }
  }

  setGroupMarker(pins: GroupMarkerObject[], markerType: string) {
    if (this.map === undefined) return;

    this.projectClusterer?.clearMarkers();
    for (let i = 0; i < pins.length; i++) {

      const marker = new google.maps.marker.AdvancedMarkerElement({
        position: { lat: pins[i].lat, lng: pins[i].lng },
        map: this.map,
        content: this.buildGroupContent(pins[i])
      });
      marker.addListener("click", () => {
        this.enterGroup(marker, pins[i]);
      });
      this.groupMarkers.push(marker);
    }
  }

  setrouteStationMarkers(pins: RouteStationMarkerObject[], markerType: string) {
    this.waitForMap().then(() => {
      for (let i = 0; i < pins.length; i++) {
        const marker = new google.maps.marker.AdvancedMarkerElement({
          position: { lat: pins[i].lat, lng: pins[i].lng },
          map: this.map,
          content: this.buildRouteStationContentNew(pins[i]),
          title: pins[i].title
        });

        if (this.userRole && this.allowedRoles.includes(this.userRole)) {
          marker.addListener("click", () => {
          this.enterRouteStation(marker, pins[i]);
        });
        }
        this.routeStationMarkers.push(marker);
      }
    });
  }

  public getPathByStellcode(stellcode: number) {
    if (this.images) {
      let imageObject = this.images.find((x) => x.stellcode == stellcode)
      return imageObject?.path as string
    }
    else return
  }

   buildContent(property: ProjectMarkerObject) {
    property.groups = this.allGroups.filter(g => g.projectId === property.id);
    let groupContent = this.groupContentInProject(property);
    const content = document.createElement("div");
    content.classList.add("property");
    if (property.active) {
      content.style.backgroundColor = "white";
      content.innerHTML = `
        <div class="icon">
          <img src='/assets/icons/folder-tree-solid-full.svg' alt="proj" height=20px />
          <div class="details"> ${property.title} </div>
        </div>
        <div class="group-container">${groupContent}</div>
      `;
      return content;
    }
    else {
      content.style.backgroundColor = "grey";
      content.innerHTML = `
        <div class="icon">
          <img src='/assets/icons/folder-tree-solid-full.svg' alt="proj" height=20px />
          <div class="details"> ${property.title} </div>
        </div>
        <div class="group-container">${groupContent}</div>
      `;
    }
      return content;
  }

  groupContentInProject(property: ProjectMarkerObject): string {
    let htmlContent = '';
    property.groups?.forEach(group => {
      htmlContent += `<span> ${group.name} </span> `
    })
    if (property.groups?.length === 0) { return '<span> Keine Gruppen </span>' }
    else return htmlContent
  }

  buildGroupContent(property: GroupMarkerObject) {
    let routeStationCount = this.routeStationcountInGroup(property)

    const content = document.createElement("div");
    content.classList.add("property");
    if (property.active) {
      content.innerHTML = `
        <div class="icon">
          <img src='/assets/icons/folder-solid.svg' alt="group" height=20px />
          <div class="details"> ${property.title}</div>       
        </div>
        <span class="group-container"> ${property.street} </span>
        <div class="group-container">${routeStationCount}</div>
        `;
      return content;
    }
    else
      content.innerHTML = `
        <div class="icon">
          <img src='/assets/icons/folder-solid.svg'  alt="group" height=20px />
          <div class="details"> ${property.title}</div>       
        </div>
        <span class="group-container"> ${property.street} </span>
        <div class="group-container">${routeStationCount}</div>
      `;
    return content;
  }

  public routeStationcountInGroup(property: GroupMarkerObject): string {
    let htmlContent = '';
    let routeStations = this.projectGroups.find(g => g.id === property.id)?.routeStations;
    if (routeStations) {
      if (routeStations.length > 0) {
        htmlContent += `<span> Anzahl RouteStations: ${routeStations.length}  </span> `
        return htmlContent
      }
      else return `<span> Anzahl RouteStations: ${routeStations.length}  </span> `
    }
    else return `<span> Anzahl RouteStations: 0  </span> `
  }

  public createBlinkerContent(property: RouteStationMarkerObject): string {
    if (property.blinker === 'einschalten') {
      return `<div class="d-flex" style="margin-bottom: -16px">
      <div class=" rounded-5 border border-black" style="background-color: yellow; height: 14px; width: 14px; margin-right: 12px; padding: 10px;">
                </div>
                      <div class="rounded-5 border border-black"
                    style="background-color: yellow; height: 14px; width: 14px; padding: 10px;">
                </div>
                </div>
`    }
    if (property.blinker === 'ausschalten') {
      return `   <div class="d-flex" style="margin-bottom: -16px">
      <div class=" rounded-5 border border-black" style="background-color: white; height: 14px; width: 14px; margin-right: 12px;padding: 10px;">
                </div>
                      <div class="rounded-5 border border-black"
                    style="background-color: white; height: 14px; width: 14px; padding: 10px;">
                </div>
                </div>`
    }
    else return ''
  }

  public createRouteStationHeader(property: RouteStationMarkerObject): string {
    return `<div class="details">
    <span class="text-center"> ${property.name} </span>
    
    </div>
    <span class="text-center group-container"> SAM ID: ${property.id} </span>`
  }

  public createBodyContent(property: RouteStationMarkerObject): string {
    if (property.stellcode === 0 && property.online === true) {
      return `<img style="height: 60px" src="${location.origin}/assets/led_default.svg">`
    }
    if (property.indicatorLed === 'ausschalten' && property.online === true && property.isAnimated === false) {
      return `<img style="height: 60px" src="${location.origin}/assets/led_default.svg">`

    }
    if (property.online === true && property.LPCam) {
      return `<img style="height: 60px" src="${location.origin}/assets/icons/camera/icon_kamera_kennzeichen_center.svg">`
    }
    if (property.online === true && property.DomeCam) {
      return `<img style="height: 60px" src="${location.origin}/assets/icons/camera/icon_kamera_verkehr_center.svg">`
    }
    if (property.online === true && property.Weather) {
      return `<img style="height: 60px" src="${location.origin}/assets/icons/data-end-channel/weather.svg">`
    }


    /* noch auf is animated prüfen */
    /* entweder wechselbild anzeigen, oder ich muss tatsächlich immer ein bild auf einer source ändern */
    /* 
    
    unknown_online feht noch property.online und aq 
    */

    if (property.indicatorLed === 'einschalten' && property.online === true && property.isAnimated === false) {
      return `<img style="height: 60px" src="${this.apiAddress + this.getPathByStellcode(property.stellcode!)}">`
    }
    if (property.indicatorLed === 'einschalten' && property.online === true && property.isAnimated === true) {
      return `<img style="height: 60px" src="${location.origin}/assets/icons/wechselbild.png"}">`
    }
    if (property.indicatorLed === 'ausschalten' && property.online === false) {
      return `<img class="default-image" src="${location.origin}/assets/icons/led_default_offline_ohne_blinker.svg">`
    }
    if (property.indicatorLed === 'einschalten' && property.online === false) {
      return `<img class="default-image" src="${location.origin}/assets/icons/led_default_offline_ohne_blinker.svg">`
    }
    if (property.indicatorLed === null && property.isBrennstoffzelle !== true && property.online === true && property.mq === true) {
      /* keine weitere prüfung ob aq oder unknown, muss ich noch durchfädeln*/
      return `<img style="background-color: white; padding: 0px; border-radius: 25px;" src="${location.origin}/assets/icons/data-end-channel/radar_aq.svg">`
    }
    if (property.indicatorLed === null && property.isBrennstoffzelle !== true && property.online === true && property.mq === false) {
      return `<img style="background-color: white; padding: 0; border-radius: 0px;" src="${location.origin}/assets/icons/icon_sst_eva.svg">`
    }
    if (property.indicatorLed === null && property.isBrennstoffzelle !== true && property.online === false && property.mq === false) {
      return `<img style="background-color: white; padding: 0; border-radius: 0px;" src="${location.origin}/assets/icons/icon_sst_eva.svg">`
    }
    if (property.isBrennstoffzelle === true && property.online === true) {
      return `<img style="height: 60px" src="${location.origin}/assets/icons/gas_meter.svg">
      <span class="text-center group-container"> Patrone 1: ${property.patrone1} %</span>
      <span class="text-center group-container"> Patrone 2: ${property.patrone2} %</span>`
    }
    if (property.isBrennstoffzelle === true && property.online === false) {
      return `<img style="height: 60px" src="${location.origin}/assets/icons/gas_meter_offline.svg">
      <span class="text-center group-container"> Patrone 1: ${property.patrone1} %</span>
      <span class="text-center group-container"> Patrone 2: ${property.patrone2} %</span>`
    }
    return `<img style="background-color: white; padding: 0; border-radius: 0px;" src="${location.origin}/assets/icons/device_unknown_offline.svg">`
  }

  buildRouteStationContentNew(property: RouteStationMarkerObject) {

    let path = this.getPathByStellcode(property.stellcode!);
    let fullPath = this.apiAddress + path;
    if (property.indicatorLed === 'ausschalten') {
      fullPath = location.origin + '/assets/led_default.svg'
    }
    const content = document.createElement("div");
    content.classList.add("propertyRS"); /* kopieren und ohne hover mit anderem namen */

    const needsStellcodeImage = property.stellcode !== undefined
      && property.stellcode !== null
      && property.stellcode !== 0;

    if (needsStellcodeImage && path === undefined) {
      content.innerHTML = `
        <div class="icon">
          <img src='/assets/icons/map-pin.svg' alt="map-pin" height=20px/>
        </div>
        <div class="details">${property.title}</div>
      `;
      return content;
    }

    /* content.innerHTML += this.createRouteStationHeader(property) */

    content.innerHTML += this.createBlinkerContent(property)

    content.innerHTML += this.createBodyContent(property)

    return content;
  }

  private waitForMap(): Promise<void> {
    if (this.map) {
      return Promise.resolve();
    } else {
      return new Promise((resolve) => {
        const checkMap = setInterval(() => {
          if (this.map) {
            clearInterval(checkMap);
            resolve();
          }
        }, 100);
      });
    }
  }
}
